import { MeshStandardMaterial, BoxGeometry, Mesh } from 'three';
import { lineDiameter, lineSegmentLength } from '@/Constants/3dConfig';

const lineMaterial = new MeshStandardMaterial({ color: 0x393349 });
// const geometry = new SphereGeometry(1, 12, 6);
const geometry = new BoxGeometry(1, 1, 1);
const scale = 1;

export function getEdgeSphere() {
    const sphere  = new Mesh(geometry, lineMaterial);
    sphere.scale.set(scale*lineDiameter, scale*lineDiameter, scale*lineDiameter);
    return sphere;
}
